import { View, Input, Button, Textarea } from "@/components/ui";
import { InputFormControl } from "@/components/shared/input-form-control";
import { Spin } from "@/components/shared/spin";
import { PrimaryAddressCheckbox } from "../primary-address-checkbox";
import { useFormState, useFormContext } from "react-hook-form";
import { FormControlError } from "@/components/shared/form-control-error";
import { Typography } from "@/components/shared/typography";
import { useAddressByPostalCodeStore } from "@/store/auth/addressByPostalCode";

interface CreateAddressFormProps {
  onSubmit?: () => void;
  createAddressLoading?: boolean;
}

export const CreateAddressForm = ({
  onSubmit,
  createAddressLoading,
}: CreateAddressFormProps) => {
  const { control, setValue } = useFormContext();
  const { errors } = useFormState({ control });
  const { loading: postalCodeLoading, fetch: addAddressByPostalCode } =
    useAddressByPostalCodeStore();

  return (
    <View className="p-4 md:p-0">
      <InputFormControl
        name="label"
        label="Label as"
        control={control}
        component={Input}
        componentProps={{
          placeholder: "Eg. Home, Office",
          maxLength: 30,
        }}
      />

      <InputFormControl
        name="postalCode"
        label="Postal Code"
        control={control}
        component={Input}
        componentProps={{
          placeholder: "Enter Postal Code",
          suffix: postalCodeLoading && <Spin />,
        }}
        changeFallBack={async (value) => {
          if (!value || value.length < 6 || value.length > 10) return;
          const result = await addAddressByPostalCode({
            requestPayload: {
              postalCode: value,
            },
          });

          if (result.data?.address) {
            setValue("fullAddress", result.data.address);
          }
        }}
      />
      <InputFormControl
        name="fullAddress"
        label="Address"
        className="mt-3"
        control={control}
        component={Textarea}
        componentProps={{
          placeholder: "Enter Address",
        }}
      />

      <Typography variant="body-lg" className="mt-3">
        Unit Number
      </Typography>
      <View className="flex flex-row gap-3">
        <InputFormControl
          name="unitFloor"
          className="flex-1"
          control={control}
          component={Input}
          componentProps={{
            placeholder: "Floor",
          }}
          hideErrorMessage
        />
        <InputFormControl
          name="apartmentNumber"
          className="flex-1"
          control={control}
          component={Input}
          componentProps={{
            placeholder: "Apt no",
          }}
          hideErrorMessage
        />
      </View>
      {errors.unitFloor?.type === "required" ||
      errors.apartmentNumber?.type === "required" ? (
        <FormControlError error="Floor and Apt No. required. Please indicate 0 if not applicable." />
      ) : (
        <Typography variant="body-sm" color="secondary-text" className="mt-1">
          If not applicable, enter 0 for Floor or Apt No.
        </Typography>
      )}

      <PrimaryAddressCheckbox />

      <View className="mt-3 flex flex-row justify-end">
        <Button
          variant="primary"
          color="CTA"
          rounded="full"
          loading={createAddressLoading}
          onClick={onSubmit}
          className="native:hidden"
          children="Save"
        />
      </View>
    </View>
  );
};
